var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_212_910)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.324 4.5509L1.04133 0.179641C0.792 -0.0598802 0.410667 -0.0598802 0.176 0.179641C-0.0586667 0.419162 -0.0586667 0.808383 0.176 1.06287L4.03333 5L0.176 8.93713C-0.0586667 9.17665 -0.0586667 9.58084 0.176 9.82036C0.410667 10.0599 0.792 10.0599 1.04133 9.82036L5.324 5.43413C5.55867 5.19461 5.55867 4.80539 5.324 4.5509Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_212_910"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.5,
    height: 10,
    fill: "white",
    transform: "matrix(-1 0 0 1 5.5 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNav);
export default __webpack_public_path__ + "static/media/arrow_nav.6a3995b16328b43b79b2a7606ef95e0a.svg";
export { ForwardRef as ReactComponent };